import React from "react";
import Translate from "../../../../modules/local/Translate";
import {GoDotFill} from "react-icons/go";
import getAliasName from "../../../../helpers/getAliasName";

export const renderCatholicHouseholdLog = (item, index) => {
    const {actions, notes = '', catholic_household_member} = item ?? {}
    const notesArrUpdate = !!notes ? notes.split('\n') : []
    const notesArrDelete = !!notes ? notes.split(':') : []

    let Content

    switch (actions) {
        case 'update':
        case 'update status':
        case 'update member':
            Content = (
                <div className="text-xs italic whitespace-pre-line">
                    {notesArrUpdate.filter(e => !!e).map((e, i) => {
                        const _array = e.split(']:')
                        return (
                            <span key={i} className="flex items-center gap-3">
                                <GoDotFill size={10} className="text-color-500"/>
                                <span className="font-medium text-color-100 whitespace-no-wrap">
                                    {`${_array[0].replace('[', '')} : `}
                                </span>
                                <span className="text-color-400">{_array[1]}</span>
                            </span>
                        )
                    })}
                </div>
            )
            break
        case 'insert member':
            Content = (
                <div className="flex items-center gap-1 text-xs italic ">
                    <GoDotFill size={10} className="text-color-500"/>
                    <span className="font-medium text-color-100 whitespace-no-wrap">
                        {`${notesArrDelete[0]} : `}
                    </span>
                    <span className="text-color-400">
                        <span className="mr-1 font-medium text-color-300">
                            {getAliasName(catholic_household_member, 'patron_saint')}
                        </span>
                        {catholic_household_member?.name}
                    </span>
                </div>
            )
            break
        case 'delete member':
            Content = (
                <div className="flex items-center gap-1 text-xs italic ">
                    <GoDotFill size={10} className="text-color-500"/>
                    <span className="font-medium text-color-100 whitespace-no-wrap">
                        {`${notesArrDelete[0]} : `}
                    </span>
                    <span className="text-color-400">{notesArrDelete[1]}</span>
                </div>
            )
            break
        default:
            return (
                <Translate>
                    {t => (
                        <span className="text-xs text-color-400 italic tracking-wide">
                            {`* ${t('No data available at this time.')}`}
                        </span>
                    )}
                </Translate>
            )
    }

  return (
      <Translate key={index}>
          {(t) => (
              <div key={index} className="space-x-2 text-sm">
                  <span className="font-semibold text-orange-400">
                      {`${t(actions)} : `}
                  </span>
                  {Content}
              </div>
          )}
      </Translate>
  )
}